import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {
	SearchTypeAttributeHistory,
	TSearchTypeAttributeHistory,
} from './constants';
import {attributeHistoryRuleDefaults} from './defaults';
import type {AttributeHistoryRule} from './types';
import {validateAttributeHistoryRule} from './validate';

export class AttributeHistoryRuleModel
	extends RuleModel<TSearchTypeAttributeHistory>
	implements AttributeHistoryRule
{
	readonly elementType = SearchTypeAttributeHistory;
	elementSubType1: 4 = attributeHistoryRuleDefaults.elementSubType1;
	elementSubType2: 0 = attributeHistoryRuleDefaults.elementSubType2;
	elementValue1 = attributeHistoryRuleDefaults.elementValue1;
	elementValue2 = attributeHistoryRuleDefaults.elementValue2;
	elementValue3: '' = attributeHistoryRuleDefaults.elementValue3;

	get isValid() {
		return validateAttributeHistoryRule(this);
	}

	constructor(params?: Partial<Omit<AttributeHistoryRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...attributeHistoryRuleDefaults, ...params});
		});

		makeObservable(this, {
			isValid: computed,
			elementValue1: observable,
			elementValue2: observable,
			setElementValue1: action,
			setElementValue2: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	setElementValue1(elementValue1: number) {
		this.elementValue1 = elementValue1;
	}

	setElementValue2(elementValue2: string) {
		this.elementValue2 = elementValue2;
	}

	/** stubbed */
	setElementValue3() {}
}

export default AttributeHistoryRuleModel;
